<template>
    <section class="reviews" v-if="count&&title">
        <div class="flex v-center reviews__titleWrapper">
            <h3 class="reviews__title">{{ title }}</h3>
            <AChip class="flex v-center ml-3" v-if="count&&title">{{ count }}</AChip>
        </div>
        <ReviewsCard v-for="review in listData"
                     :key="review.id"
                     :photo="review.photo"
                     :rapliseble="review.rapliseble"
                     :author="review.author"
                     :position="review.position"
                     :company="review.company"
                     :date="review.date"
                     :text="review.text"
                     :replies="review.replies"
        />
        <ABtn v-if="listData?.length<count" label="Показать еще" class="transparent gray w-100" @click="load"/>

    </section>
</template>

<script>
import {AChip, ABtn} from '~/components/ui'
import ReviewsCard from "~/components/cards/ReviewsCard";

export default {
    name: "ReviewsListSection",
    props: {
        title: {
            type: String,
            default: 'Отзывы'
        },
        count: {
            type: Number,
            default: 0
        },
        listData: {
            type: Object,
            default: {}
        }
    },
    components: {ReviewsCard, AChip, ABtn},
    setup() {
        const load = () => {
            console.log('load reviews..')
        }

        return {
            load
        }
    }
}
</script>

<style scoped>

</style>